<template>
  <div class="addDriversLicenseInfo">
    <QS-h4-title title="驾驶证信息" />
    <el-form
      :model="individualCustomerInfo"
      ref="addDriversLicenseInfo"
      label-width="140px"
      :rules="formRule"
    >
      <!-- <column-box
        :column="2"
        label-width="60px"
      > -->
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item prop="driverLicence" :label="'驾驶证照片（正）' + columnSeparator">
            <UploadCommon
              fileTitle="(ocr识别)"
              :fileList="driverLicenceUrl"
              :isAlone="true"
              @uploadSuccess="driverLicenceSuccess"
              @deleteUploadHandle="delDriverLicenceUrl"
              :sizeType="4"
              commonUpload
              group="assert"
              code="assert_driver_license_front_pic"
            ></UploadCommon>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item prop="driverLicenceBack" :label="'驾驶证照片（背）' + columnSeparator">
            <UploadCommon
              fileTitle="(ocr识别)"
              :fileList="driverLicenceBackUrl"
              :isAlone="true"
              @uploadSuccess="driverLicenceBackSuccess"
              @deleteUploadHandle="delDriverLicenceBackUrl"
              :sizeType="4"
              commonUpload
              group="assert"
              code="assert_driver_license_back_pic"
            ></UploadCommon>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- </column-box> -->
      <!-- <column-box :column="3" label-width="150px"> -->
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item
            prop="driverLicenceFilesNo"
            :label="`驾驶证档案编号${columnSeparator}`"
          >
            <el-input
              v-space="true"
              v-uppercase="true"
              v-model="individualCustomerInfo.driverLicenceFilesNo"
              placeholder="请输入"
              clearable
              maxlength="20"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            prop="driverLicenceNo"
            :label="`驾驶证号${columnSeparator}`"
          >
            <el-input
              v-space="true"
              v-model="individualCustomerInfo.driverLicenceNo"
              v-alphanumeric="true"
              placeholder="请输入"
              clearable
              maxlength="18"
            >
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            prop="driverLicenceCarModel"
            :label="`准驾车型${columnSeparator}`"
          >
            <el-input
              v-space="true"
              v-model="individualCustomerInfo.driverLicenceCarModel"
              placeholder="请输入"
              clearable
              maxlength="20"
            >
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="driverLicenceFirstDate"
            :label="'驾驶证初次领证日期' + columnSeparator"
          >
            <el-date-picker
              v-model="individualCustomerInfo.driverLicenceFirstDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            prop="driverLicenceValidDate"
            :label="'驾驶证有效期' + columnSeparator"
          >
            <el-date-picker
              v-model="individualCustomerInfo.driverLicenceValidDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              format="yyyy-MM-dd"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- </column-box> -->
    </el-form>
  </div>
</template>

<script>
import {
  isDate,
} from '@/utils/extendFormVaildate.js'

import {
  ocrDriverLicense,
} from '@/api/carManage'

export default {
  props: {
    addFormData: {
      type: Object,
      default: () => ({}),
    },
    driverLicenceValidDateRequired: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    addFormData: {
      handler(val) {
        // 是否回显
        if (val.individualCustomerVo) {
          this.driverLicenceUrl = val.individualCustomerVo.driverLicenceUrl || []
          this.driverLicenceBackUrl = val.individualCustomerVo.driverLicenceBackUrl || []
          this.individualCustomerInfo = {
            driverLicenceValidDate: val.individualCustomerVo.driverLicenceValidDate || '', // 驾驶证有效期
            driverLicenceFirstDate: val.individualCustomerVo.driverLicenceFirstDate || '', // 驾驶证初次领证日期
            driverLicenceUrl: val.individualCustomerVo.driverLicenceUrl || '', // 驾驶证照片（正）
            driverLicenceBackUrl: val.individualCustomerVo.driverLicenceBackUrl || '', // 驾驶证照片（背）
            driverLicenceCarModel: val.individualCustomerVo.driverLicenceCarModel || '', // 准驾车型
            driverLicenceFilesNo: val.individualCustomerVo.driverLicenceFilesNo || '', // 驾驶证档案编号
            driverLicenceNo: val.individualCustomerVo.driverLicenceNo || '', // 驾驶证号
          }
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      driverLicenceUrl: [],
      driverLicenceBackUrl: [],
      individualCustomerInfo: {
        driverLicenceValidDate: '', // 驾驶证有效期
        driverLicenceFirstDate: '', // 驾驶证初次领证日期
        driverLicenceUrl: '', // 驾驶证照片（正）
        driverLicenceBackUrl: '', // 驾驶证照片（背）
        driverLicenceCarModel: '', // 准驾车型
        driverLicenceFilesNo: '', // 驾驶证档案编号
        driverLicenceNo: '', // 驾驶证号
      },
    }
  },
  computed: {
    formRule() {
      return {
        driverLicenceValidDate: this.driverLicenceValidDateRequired
          ? [{ required: true, message: '请选择驾驶证有效期', trigger: 'change' }]
          : [],
      }
    },
  },
  methods: {
    driverLicenceSuccess(url) {
      this.individualCustomerInfo.driverLicenceUrl = JSON.stringify([url])
      ocrDriverLicense({
        imageUrl: url,
        cardSide: 'FRONT',
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          const { driveClass, endDate, startDate, firstIssueDate, issueDate } = data
          this.individualCustomerInfo.driverLicenceCarModel = driveClass
          this.individualCustomerInfo.driverLicenceFirstDate = [firstIssueDate, startDate, issueDate].find(isDate) || ''
          this.individualCustomerInfo.driverLicenceValidDate = isDate(endDate) ? endDate : ''
        }
      })
    },
    driverLicenceBackSuccess(url) {
      this.individualCustomerInfo.driverLicenceBackUrl = JSON.stringify([url])
      ocrDriverLicense({
        imageUrl: url,
        cardSide: 'BACK',
      }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          const { archivesCode } = data
          this.individualCustomerInfo.driverLicenceFilesNo = archivesCode
        }
      })
    },
    // 驾驶证照片（正）删除事件
    delDriverLicenceUrl() {
      this.individualCustomerInfo.driverLicenceUrl = null
    },
    // 驾驶证照片（反）删除事件
    delDriverLicenceBackUrl() {
      this.individualCustomerInfo.driverLicenceBackUrl = null
    },
    // 驾驶证校验
    // eslint-disable-next-line vue/no-unused-properties
    validate() {
      let driver = false
      this.$refs.addDriversLicenseInfo.validate((valid) => {
        if (valid) {
          driver = true
        }
      })
      return driver
    },
  },
}
</script>

<style lang="scss" scoped>
.addDriversLicenseInfo{

}
</style>
